import { Controller } from "@hotwired/stimulus";

const SHOWN_CLASS = "in";
const TRANSITIONING_CLASS = "collapsing";

export default class extends Controller {
  static values = { panels: String };

  expand() {
    this.toggleAll(false);
  }

  collapse() {
    this.toggleAll(true);
  }

  toggleAll(currentlyShown) {
    this.panels
      .filter((panel) => panel.classList.contains(SHOWN_CLASS) === currentlyShown)
      .filter((panel) => !panel.classList.contains(TRANSITIONING_CLASS))
      .forEach((panel) => this.toggleFor(panel)?.click());
  }

  get panels() {
    return Array.from(document.querySelectorAll(this.panelsValue));
  }

  toggleFor(panel) {
    return document.querySelector(
      `[data-toggle="collapse"][href="#${panel.id}"], [data-toggle="collapse"][data-target="#${panel.id}"]`
    );
  }
}
